import React, {useEffect} from 'react';
import { useSelector } from 'react-redux';
import "./style.css";
import { getLanguage } from "../../components/LanguageModal/reducer";
import translations from "../../components/LanguageModal/translations";
import SadIconAsia from '../../icons/sad-icon.png';
import SadIconGras from "../../icons/sad-icon-green.png";
import {getOrders, getPlacedOrder} from "../Orders/reducer";
import {Dimmer, Header, Label, Loader} from "semantic-ui-react";
import {addProduct, removeAllProductsFromCart} from "../Cart/actions";
import CheckoutSteps, {CHECKOUT_STEP_CONFIRM} from "../../components/CheckoutSteps";
import OrderCard from "../../components/OrderCard";
import {getProducts, getProductsFetching} from "../Products/reducer";
import {fetchProducts, PRODUCTS_PAGE_COUNT} from "../Products/actions";
import {fetchUserData} from "../../components/UserLogin/actions";
import {getAuthFetching} from "../../components/UserLogin/reducer";
import {removeCoupon} from "../../components/CouponCard/actions";
import {getDiscount} from "../../components/CouponCard/reducer";
import {toastr} from "react-redux-toastr";
import {getTypeExhibition} from "../Home/reducer";
import {
    ADDRESS_COMPANY,
    ADDRESS_COMPANY_ADDR, ADDRESS_COMPANY_CHIEF_NAME, ADDRESS_COMPANY_CHIEF_POST,
    ADDRESS_COMPANY_INN,
    ADDRESS_COMPANY_JOB_TITLE,
    ADDRESS_COMPANY_KPP,
    ADDRESS_COMPANY_OGRN,
    ADDRESS_COUNTRY,
    ADDRESS_EMAIL,
    ADDRESS_FIRSTNAME,
    ADDRESS_LASTNAME,
    ADDRESS_PHONE,
    ADDRESS_PHONE_COUNTRY,
    ADDRESS_STATE, setAddressFields
} from "../../components/AddressCard/actions";
import {getAddressFields} from "../../components/AddressCard/reducer";
import {openAuth} from "../../components/NavTopBar/actions";


const Ticket = (props) => {
    const { isLoggedIn, dispatch, userData, token, navigate, mixpanel} = props;
    const language = useSelector(getLanguage);
    const languageString = language[0] + language[1];


    const t = (key) => {
        const translation = translations?.[languageString];
        return translation?.[key] || key;
    };

    const typeExhibition = getTypeExhibition(useSelector((state) => state.exhibition));
    const dataExhibitions = {
        asia: {
            sadIcon: SadIconAsia,
            event: 'ASIAEXPO 2025'
        },
        gras: {
            sadIcon: SadIconGras,
            event: 'GRAS 2025'
        }
    }

    const orders = isLoggedIn && userData?.orders ? userData.orders : [];
    const order = typeExhibition && orders.filter((item) => item?.event_id === dataExhibitions[typeExhibition].event)[0]
    // console.log(order)
    const products = useSelector((state) => getProducts(state.products)) || [];
    const productsFetching = useSelector((state) => getProductsFetching(state.products));
    const isFetchingUserData = useSelector((state) => getAuthFetching(state.userLogin));
    const loaderText = t('loadInfo');

    const product = typeExhibition
        ? products.find(p => p?.tags?.find(t => t?.slug === typeExhibition))
        : null;

    const coupon = useSelector((state) => getDiscount(state.discount));
    const couponCode = coupon?.data?.coupon ?? '';

    const createNew = !isLoggedIn || !order;

    const address_fields = useSelector((state) => getAddressFields(state.address)) || {};

    useEffect(() => {
        window.scrollTo(0, 0);

        if (token) {
            dispatch(fetchUserData(token, languageString));
        }

        if (couponCode) {
            dispatch(removeCoupon(couponCode));
        }

        if (!products || products.length === 0) {
            dispatch(fetchProducts({
                page: 1,
                per_page: PRODUCTS_PAGE_COUNT,
                order: 'asc',
                orderby: 'id',
                lang: languageString,
            }));
        }

        if (mixpanel) {
            mixpanel.track('View. Ticket')
        }

    }, [token, languageString, products.length, couponCode, mixpanel, dispatch]);

    const handleBuyTicket = () => {
        if (!product) {
            console.error('Product not found. Products:', products, 'TypeExhibition:', typeExhibition);
            const noProductMessage = languageString === "ru"
                ? "Продукт не найден. Пожалуйста, обновите страницу."
                : 'Product not found. Please refresh the page.';
            console.log('No product error:', noProductMessage);
            toastr.error(noProductMessage);
            return;
        }

        if (!product.id || !product.name || product.price === undefined) {
            console.error('Invalid product data:', product);
            const invalidProductMessage = languageString === "ru"
                ? "Некорректные данные продукта. Пожалуйста, обновите страницу."
                : 'Invalid product data. Please refresh the page.';
            console.log('Invalid product error:', invalidProductMessage);
            toastr.error(invalidProductMessage);
            return;
        }


        try {
            dispatch(removeAllProductsFromCart());

            dispatch(addProduct(
                product.id,
                product.name,
                product.price,
                product.images?.[0] || '',
                product.virtual,
                null,
                null,
            ));


            if (isLoggedIn && userData?.billing) {
                const billing = userData.billing;
                const updatedAddressFields = { ...address_fields };

                updatedAddressFields[ADDRESS_FIRSTNAME] = billing.first_name || '';
                updatedAddressFields[ADDRESS_LASTNAME] = billing.last_name || '';
                updatedAddressFields[ADDRESS_COUNTRY] = billing.country || '';
                updatedAddressFields[ADDRESS_STATE] = billing.state || '';
                updatedAddressFields[ADDRESS_PHONE] = billing.phone || '';
                updatedAddressFields[ADDRESS_PHONE_COUNTRY] = billing.phone_country || '';
                updatedAddressFields[ADDRESS_EMAIL] = billing.email || '';
                updatedAddressFields[ADDRESS_COMPANY] = billing.company || '';
                updatedAddressFields[ADDRESS_COMPANY_JOB_TITLE] = billing.company_job_title || '';

                dispatch(setAddressFields(updatedAddressFields));
            }

            navigate('/checkout-step-shipping');
        } catch (error) {
            console.error('Error in handleBuyTicket:', error);
            const genericError = languageString === "ru"
                ? "Произошла ошибка. Пожалуйста, попробуйте еще раз."
                : 'An error occurred. Please try again.';
            toastr.error(genericError);
        }
    }

    if (isFetchingUserData || productsFetching) {
        return (
            <Dimmer active inverted>
                <Loader active>{t("loadInfo")}...</Loader>
            </Dimmer>
        );
    }

    if (createNew) {
        return (
            <div className="no-ticket-page">
                <img
                    width={50}
                    height={50}
                    src={dataExhibitions[typeExhibition].sadIcon}
                    alt=""
                    styl
                    onError={(e) => {
                        e.target.style.display = 'none';
                    }}
                />


                <div className="no-ticket-message">
                    {!isLoggedIn ? (
                        <span><b>{t('notAuthorized')}</b><br/>{t('pleaseLogInAndPay')}</span>
                    ) : (
                        <span>{t('youDontHaveTicket')}<br/>{t('pleasePay')}</span>
                    )}
                </div>
                <div className="button-container" style={{marginTop: '20px'}}>
                    {!isLoggedIn ? (
                            <button
                                className={`buy-ticket-button ${typeExhibition}`}
                                onClick={() => {
                                    dispatch(openAuth())
                                }}
                            >
                                <span>{t('login')}</span>
                            </button>
                        ) : (
                            <button
                            className={`buy-ticket-button ${typeExhibition}`}
                            onClick={(e) => {
                                console.log('Button clicked!', e);
                                e.preventDefault();
                                e.stopPropagation();
                                handleBuyTicket();
                            }}
                            >
                                <span>{t('buyTicket')}</span>
                            </button>
                        )
                    }
                </div>
            </div>
        );
    }

    if (!order) {
        return (
            <div className="error-page">
                <p>{t('orderNotFound') || 'Order not found'}</p>
            </div>
        );
    }
    return (
        <div>
            <CheckoutSteps step={CHECKOUT_STEP_CONFIRM}/>
            {/*<Header textAlign="center" className='checkout-step-confirm-header'>*/}
            {/*    {t('yourUniqueCode')} - {order.id}*/}
            {/*</Header>*/}
            <OrderCard
                order={order}
                {...props}
            />

            <span className="checkout-step-confirm-text-asiaexpo">
                {(+order?.total > 0) ?
                    t('PresentYourCodeAtTheRegistration')
                    :
                    t('PresentYourQrCodeAtTheRegistration')
                }
                <br/>
                {t('ASIAEXPOToReceiveYourBadge')}
            </span>
        </div>
    );
};

export default Ticket;